export default "__VITE_ASSET__C3Mac$s2__"